var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"im-loading-wrap"},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-content"},[_c('img',{attrs:{"src":require("./loading.gif"),"alt":""}})])
}]

export { render, staticRenderFns }